import * as yup from 'yup'

const schemaOrganizationUser = (isEdit, isUserCreation) =>
  yup.object().shape({
    organizationId: yup
      .object()
      .nullable()
      .when([], {
        is: () => !isEdit && isUserCreation,
        then: (schema) => schema.required('Selecione um Grupo Advisor'),
        otherwise: (schema) => schema.notRequired(),
      }),
    profileId: yup.string().required(),
  })

export default schemaOrganizationUser
